var modules_efc4e723 = {"container":"_l3exh2","container_video":"_1tnt1a5","placeholder":"_rfslaa","placeholder_side":"_1ng5znc","placeholder_tgbm7":"_qnbpfb","placeholder_top":"_y2u40n","placeholder_video":"_26hvjp"};
import "../../assets/R1bmuVWY.css";

export { modules_efc4e723 as default };
//# sourceMappingURL=styles.module.scss.js.map
